<template>
  <nav class='ba-pagination ba-md ba-flex ba-w-100'>
    <ul class='ba-list ba-flex ba-w-100'>
      <li class='ba-nav-item' style="margin-right: auto;">
        <a class='ba-back' href='#' aria-label="Previous" @click.prevent="pagination.current_page === 1 ? undefined : changePage(pagination.current_page - 1)" :class="pagination.current_page === 1 ? 'disabled' : 'ba-is-active'">
          <span class='ba-icon'>
            <builderall-icon code='arrow-left' :class="pagination.current_page === 1 ? 'ba-color-black18' : ''" />
          </span>
          <span class="ba-text-uppercase">{{ $t('ct-previous') }}</span>
        </a>
      </li>
      <li class='ba-nav-item' v-for="(page, index) in pagesNumber" :key="index"
        :class="{ 'active': page == pagination.current_page }">
        <a href="#" class="ba-link" :class="{ 'ba-is-active': page == pagination.current_page }"
          v-on:click.prevent="changePage(page)">{{ page }}</a>
      </li>
      <li class='ba-nav-item' style="margin-left: auto;">
        <a class='ba-next' :class="pagination.current_page === pagination.last_page ? 'disabled' : 'ba-is-active'" href='#' 
          @click.prevent="pagination.current_page === pagination.last_page ? undefined : changePage(pagination.current_page + 1)">
          <span class="ba-text-uppercase">{{ $t('ct-next') }}</span>
          <span class='ba-icon'>
            <builderall-icon code='arrow-right' :class="pagination.current_page === pagination.last_page ? 'ba-color-black18' : ''" />
          </span>
        </a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true
    },
    offset: {
      type: Number,
      default: 4
    }
  },
  computed: {
    pagesNumber() {
      if (!this.pagination.to) {
        return [];
      }
      let from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      let to = from + this.offset * 2;
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      let pagesArray = [];
      for (let page = from; page <= to; page++) {
        pagesArray.push(page);
      }
      return pagesArray;
    }
  },
  methods: {
    changePage(page) {
        this.pagination.current_page = page;
        this.$emit('paginate', page);
    }
  }
};
</script>
<style scoped lang="scss">
.disabled {
  cursor: not-allowed;
  color: #92AAC6	
}
builderall-icon{
  --builderall-icon-color: currentColor !important;
}

builderall-icon:hover{
  --builderall-icon-color: currentColor !important;
}
.ba-pagination {
  background: rgba(255, 255, 255, 0.4);
  border-radius: 14px;
  .ba-list {
    margin: 0;
    padding: 20px;
    .ba-nav-item {
      &.active {
        background-color: #D5E7F0;
      }
      .ba-link {
        padding: 9.6px 16px;
        border-radius: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/Pagination.vue